import $ from "jquery"
import TaskStore from "../../store/TaskStore"
import ProjectStore from "../../store/ProjectStore"
import CustomerStore from "../../store/CustomerStore"
import messageResource from "../../messageResource"
import {DateFormat} from "../../date_format"
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import {selectStatusIdByTask} from "../../workflowStatus/selectors"
import {setEventPreventHidingEditTaskSlidingPanel} from "../../panels/utils"
import {getWorkflowStatuses} from "../../entities/selectors"
import CommentsNumberContainer from '../../taskManagement/components/CommentsNumberContainer'
import {getOpenTaskId} from '../../panels/task/editPanel/selectors'
import {SubmitTTFormConstants} from 'constants'
import CreateTasksPopupController from '../../addNewTasks/CreateTasksPopupController'
import {openEditTaskPanel} from '../../panels/task/editPanel/actions'
import TimeTrackPageFeatureDiffController from '../TimeTrackPageFeatureDiffController'
import View from '../../View'
import EditTaskPanelContainer from '../components/EditTaskPanelContainer'
import ChangeTaskStatusButton from './ChangeTaskStatusButton'
import {getTaskStatusIdElement, getTaskStatusModifiedElement, getTaskStatusNameElement} from './utils'
import {WorkflowStatusType} from '../../workflowStatus/constants'

const dateFormat = new DateFormat(window.SystemSettings.dateFormat);

class Mediator extends View {
    constructor({
        data,
        deleteTaskCallback = () => {},
        editTaskWithReloadCallback = () => {},
        reopenTaskCallback = (taskId, statusId, statusName, isTaskInArchivedProject) => {},
        openTaskPanel = taskId => {},
    }) {
        super();
        this.data = data
        this.params = {
            deleteTaskCallback,
            editTaskWithReloadCallback,
            reopenTaskCallback,
        }

        this.actions = {
            openTaskPanel,
        }

        this.state = {
            workflowStatuses: {},
            openTaskId: null,
        }

        this.onStatePropertyChanged('openTaskId', this._handleOpenTaskIdChange)
    }

    init() {
        super.init()
        new TimeTrackPageFeatureDiffController().init()

        this.$pageEl = $('#container');

        new EditTaskPanelContainer({
            onTaskDeletedCb: (taskId) => this.params.deleteTaskCallback(taskId),
            onTaskMovedCb: taskId => this.updateTaskRow(taskId),
        }).init()

        this.workflowStatusIconsMap = {};
        this.commentsCountersMap = {}

        for (let task of SubmitTTData.tasks.getValues()) {
            const id = task.id;
            const $taskRow = $('#taskRow' + id)
            const $idInput = $(getTaskStatusIdElement(id))
            const $workStatusIcon = $taskRow.find(".workStatusIconContainer");
            this.workflowStatusIconsMap[id] = new ChangeTaskStatusButton({
                taskId: id,
                curStatusId: selectStatusIdByTask(task),
                onStatusChangedCb: (statusId) => {
                    this._changeStatusOfTask(id, selectStatusIdByTask(task), statusId)
                    this._handleStatusChange(id, selectStatusIdByTask(task), statusId)
                }
            }).init( $workStatusIcon)

            this._changeStatusOfTask(id, selectStatusIdByTask(task), Number($idInput.val()))
            this.workflowStatusIconsMap[id].setState({
                canBeReopened: task.canBeReopened,
                editable: !task.notAssigned,
            })

            this.commentsCountersMap[id] = new CommentsNumberContainer().init($taskRow.find('.commentsNumberPlaceholder'))
            this.commentsCountersMap[id].setState({
                commentsNumber: task.commentsNumber,
            })
        }

        this.createTasksPopupController = new CreateTasksPopupController({
            successTaskCreationCb: (result) => this._successTaskCreationCallback(result),
            serviceName: "AddNewTasksService"
        });

        $('#addTaskButtonId').click(() => this.createTasksPopupController.showPopup(null, null, this.data.selectedUserId, false, { taskCreationDate: this.data.submitTtDate }))

        this.subscribeToEvents();
        return this;
    }

    subscribeToEvents() {
        const self = this

        $(".clickableTask").click(function(event) {
            setEventPreventHidingEditTaskSlidingPanel(event)
            let taskId = $(this).data("taskid")
            self.actions.openTaskPanel(taskId)
        });

        $(document).on('editTaskPanel_updateTask', (e, {taskId, prevTaskState}) => {
            this._onTaskChanged(taskId, prevTaskState)
        })
    }

    _handleOpenTaskIdChange = (taskId) => {
        let $actualTTRows = $("#actualTTRows")
        $actualTTRows.find(".taskRow.editing").removeClass("editing")
        if (taskId) {
            $actualTTRows.find("#taskRow" + taskId).addClass("editing")
        }
    }

    _onTaskChanged(taskId, prevTaskState){
        const task = TaskStore.get(taskId);
        if (!task || !prevTaskState || task.id !== prevTaskState.id)
            return
        const currWorkflowStatus = this.state.workflowStatuses[selectStatusIdByTask(task)];
        const prevWorkflowStatus = this.state.workflowStatuses[selectStatusIdByTask(prevTaskState)];

        if (!!prevWorkflowStatus && currWorkflowStatus.id !== prevWorkflowStatus.id) {
            this._changeStatusOfTask(taskId, currWorkflowStatus.id, currWorkflowStatus.id);
            this._handleStatusChange(taskId, currWorkflowStatus.id, currWorkflowStatus.id)
        }
        if (!!prevWorkflowStatus && currWorkflowStatus.type !== prevWorkflowStatus.type) {
            this.params.editTaskWithReloadCallback(taskId);
        }
        this.updateTaskRow(taskId);
    }

    updateTaskRow(taskId) {
        const $taskRow = $('#taskRow' + taskId)
        const task = TaskStore.get(taskId)

        if (!task)
            return
        $taskRow.find('.taskNameColumn  .task').text(task['name'])
        $taskRow.find('.taskNameColumn .customer').text(CustomerStore.get(task.customerId)['name'])
        $taskRow.find('.taskNameColumn .project').text(ProjectStore.get(task.projectId)['name'])

        const $newDeadlineSpan = $("<span/>")
        $newDeadlineSpan.text(task.deadline ? dateFormat.formatDate(task.deadline) : messageResource.getMessage('common.not_available'))
        if (task.deadline) {
            $newDeadlineSpan.addClass((currentUserTime().clearTime().getTime() > task.deadline.getTime()) ? "deadline_in_the_past" : "deadline")
        } else {
            $newDeadlineSpan.addClass("deadline_NA")
        }
        const $deadlineCell = $taskRow.find('.deadlineCell')
        $deadlineCell.empty()
        $deadlineCell.append($newDeadlineSpan)

        this._updateCommentsNumber(taskId, task.commentsNumber)
    }

    _updateCommentsNumber(taskId, commentsNumber) {
        this.commentsCountersMap[taskId].setState({
            commentsNumber: commentsNumber,
        })
    }

    _successTaskCreationCallback( result ) {
        let createdTaskIds = result.createdTaskIdsList.list;
        const cannotAddTasksForOtherUserDisabledOrDeletedError = result.cannotAddTasksForOtherUserDisabledOrDeletedError;

        if (typeof window.disableWarningOnUnloadPage !== typeof undefined)
            window.disableWarningOnUnloadPage();

        if (cannotAddTasksForOtherUserDisabledOrDeletedError)
        {
            document.location.href='<html:rewrite page="/user/submit_tt.do"/>';
        }
        else
        {
            if( !createdTaskIds )
                createdTaskIds = [];

            document.SubmitTTForm.pageAction.value = SubmitTTFormConstants.HIGHLIGHT_TASKS_ACTION;
            document.SubmitTTForm.addTaskList.value = createdTaskIds.join( "," );
            document.SubmitTTForm.submit();
        }
    }

    _changeStatusOfTask(taskId, curStatusId, newStatusId) {
        const curStatus = this.state.workflowStatuses[curStatusId]
        const newStatus = this.state.workflowStatuses[newStatusId]
        this.workflowStatusIconsMap[taskId].setState({
            newStatus: newStatus,
            curStatus: curStatus,
        })

        $(getTaskStatusIdElement(taskId)).val(newStatusId)
        $(getTaskStatusNameElement(taskId)).val(newStatus.name)
        $(getTaskStatusModifiedElement(taskId)).val(curStatusId !== newStatusId)

        if (curStatus.type === WorkflowStatusType.COMPLETED && newStatus.type === WorkflowStatusType.OPEN) {
            this._reopenTask(taskId, newStatus.id, newStatus.name)
        } else {
            this._updateCompletedStateOfTask(taskId, curStatus.type, newStatus.type)
        }
    }

    _handleStatusChange(taskId, curStatusId, newStatusId) {
        if (curStatusId !== newStatusId) {
            window.SubmitTTChanges.registerChange("statusChanged_"+taskId);
            window.submitTTManager.handleChange(true, false);
        } else {
            window.SubmitTTChanges.unregisterChange("statusChanged_"+taskId);
        }
    }

    _updateCompletedStateOfTask(taskId, curStatusType, newStatusType) {
        const $taskRow = $('#taskRow' + taskId)
        $taskRow.toggleClass('markedCompleted', curStatusType === WorkflowStatusType.OPEN && newStatusType === WorkflowStatusType.COMPLETED)
    }

    _reopenTask(taskId, newStatusId, newStatusName) {
        const task = SubmitTTData.getTaskById(taskId)
        const taskInArchivedProject = !!task && task.inArchivedProject;

        this.params.reopenTaskCallback(taskId, newStatusId, newStatusName, taskInArchivedProject)
    }
}

export default connect(
    state => ({
        workflowStatuses: getWorkflowStatuses(state),
        openTaskId: getOpenTaskId(state),
    }),
    dispatch => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
    })
)(Mediator)


// WEBPACK FOOTER //
// ./web/js/user/entertt/Mediator.js